import { Link } from "@tanstack/react-router";

export type TryToolProps = {
  /** Internal tool path, e.g. `/gtin-validator`. */
  to: string;
  /** Display label, e.g. "GTIN Validator". */
  label: string;
  /** One-line tagline shown under the label. */
  description: string;
  /** The value that gets pre-loaded into the tool, e.g. "5012345678900". */
  value?: string;
  /** Override the CTA text. */
  cta?: string;
  /** Override the query-string param name. Defaults to "value". */
  paramName?: string;
};

/**
 * In-text pointer that deep-links the reader into a ReadBarcode tool with a
 * pre-filled input. The matching tool reads the query parameter via
 * `usePrefillValue`. Rendered as a plain paragraph with a text link, because
 * it sits inside #mv-content, which holds no buttons or tool UI.
 */
export function TryTool({ to, label, description, value, cta, paramName = "value" }: TryToolProps) {
  const href = value ? `${to}?${paramName}=${encodeURIComponent(value)}` : to;
  const ctaLabel = cta ?? (value ? `Open with ${truncateForCta(value)}` : "Open the tool");
  return (
    <p>
      <strong>{label}</strong>
      {`: ${description} `}
      <Link to={href}>{`${ctaLabel} →`}</Link>
    </p>
  );
}

function truncateForCta(v: string): string {
  if (v.length <= 16) return v;
  return v.slice(0, 14) + "…";
}
